import { curatedThumb } from "@softmax/web-features/replay/art";

import { type StorePagePublic } from "@/features/store-editor/records";

import { previewHeroArt } from "@/features/preview/content/preview-content";

import { type PreviewMediaItem } from "../content/preview-details.types";

import { composeOverrideMedia } from "../media/compose-preview-media";

export function previewHeroMedia({
  published,
  coworldSlug,
  coworldName,
}: {
  published: StorePagePublic | null;
  coworldSlug: string;
  coworldName: string;
}): PreviewMediaItem[] {
  if (published?.content.hero_media?.length)
    return composeOverrideMedia({
      heroMediaOverride: published.content.hero_media,
      showLiveReplay: false,
      replay: null,
      replayUnfit: false,
    });

  if (previewHeroArt[coworldSlug] === "generals-board")
    return [
      {
        kind: "board",
        src: "generals-board",
        alt: `${coworldName}, live`,
      },
    ];

  const art = curatedThumb(coworldSlug);
  return art ? [{ kind: "capture", src: art, alt: coworldName }] : [];
}
